import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
// import SalesMenu from 'components/SalesReport/SalesMenu.jsx'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from 'react-awesome-modal';
import {connect}  from  "react-redux";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

var todayDate = new Date();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
class RupaySettlementReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            FrequencyList:[{value:"daily", label: "Daily"},{value:"weekly", label: "Weekly"},{value:"monthly", label: "Monthly"}],
            frequency:'',
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: ''
        }
    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        const tabsPermissions = localStorage.tabsPermissions;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            tabsPermissionsArray:tabsPermissions,
            user_id:decoded._id
        });
        this._getAllMerchants();
        this._get_filtered_daily_settlement_report('','','','','','', this.state.yestSend, this.state.todSend);
        this._get_acq_banks();
        this._get_issuing_banks();
        this._get_city();
    }
    handleChange(){

    }
    downLoadDailySettlementReport (e){

        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            fr: this.state.frequency,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            download: true
        };
        this.setState({
            is_download: false,
            model_visible: true
        });
        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/daily-settlement-reports-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName = xhr.getResponseHeader('Content-Disposition').split("=")[1];
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.url);
    }
    _get_filtered_daily_settlement_report(mids, cids, sids, bids, cityids, fr, fromdate, todate) {
        //console.log(mids); console.log(cids); console.log(sids); console.log(bids); console.log(cityids); console.log(fr);
        if ($.fn.DataTable.isDataTable('#DailySettTable')) {
            $('#DailySettTable').DataTable().clear().destroy();
        }
        var postData = {
            mids: mids,
            cids: cids,
            sids: sids,
            bids: bids,
            cityids: cityids,
            fr: fr,
            yestSend: fromdate,
            todSend: todate,
        };
        var DailySalesReports = $('#DailySettTable').DataTable(
            {
                order:[],
                "dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : true,
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/daily-settlement-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        console.log("sdata");
                        console.log(json.data);
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },

                columns: [
                    {"data":"Merchant", "width": "150px"},
                    {"data":"Chain", "width": "150px"},
                    {"data":"Store", "width": "100px"},
                    {"data":"Pin Code", "width": "50px"},
                    {"data":"City", "width": "50px"},
                    {"data":"Acquirer Bank","width": "50px"},
                    {"data":"Utid"},
                    {"data":"Btid"},
                    {"data":"Settlement Date"},
                    {"data":"Total Sale Amount_False"},
                    {"data":"Total Sale Amount_True"},
                    {"data":"Total Sale Count_False"},
                    {"data":"Total Sale Count_True"}
                ],
            });
    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            response.data.map((merchant,index) => {
                this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
            });
        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:null
        });
        this._get_filtered_daily_settlement_report(midArray, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,this.state.frequency,
            this.state.yestSend, this.state.todSend);
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                merchant_code: midArray
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected==null){
            value = null;
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
            });
        }
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected
        });
        this._get_filtered_daily_settlement_report(this.state.merchantID, cidArray, this.state.storeID, this.state.acqBankIds, this.state.cityIds, this.state.frequency,
            this.state.yestSend, this.state.todSend);

        axios.post(config.get('API_URL')+'/reports/get-store/', {
                chain_code: cidArray
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => { console.log(response);
            let storeList = [];
            this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList
            })
        });
    }

    changeStore(login_type, optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected==null){
            value = null;
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
        this._get_filtered_daily_settlement_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,this.state.frequency,
            this.state.yestSend, this.state.todSend);
    }
    _get_acq_banks(){
        axios.get(config.get('API_URL')+'/reports/acq-banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            response.data.map((acqBank,index) => {
                this.state.acqBankList.push({value: acqBank.acquiring_bank_id, label: acqBank.acq_bank_name})
            });
        });
        this.setState({
            loading:false
        })
    }
    change_acq_banks(optionSelected){ console.log(optionSelected);
        let value='';
        let acqBankArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                acqBankArray.push(mids.value)
            });
        }
        this.setState({
            acqBankIds:acqBankArray,
            acqBankValue:optionSelected,
        });
        this._get_filtered_daily_settlement_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds, this.state.frequency,
            this.state.yestSend, this.state.todSend);
    }
    _get_city(){
        axios.get(config.get('API_URL')+'/reports/get-city/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            response.data.map((city,index) => {
                this.state.cityLists.push({value: city.city_name, label: city.city_name})
            });
        });
        this.setState({
            loading:false
        })
    }
    changeCity(optionSelected){ console.log(optionSelected);
        let value='';
        let cityArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                cityArray.push(mids.value)
            });
        }
        this.setState({
            cityIds:cityArray,
            cityValue:optionSelected,
        });
        this._get_filtered_daily_settlement_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, cityArray, this.state.frequency,
            this.state.yestSend, this.state.todSend)
    }
    _get_issuing_banks(){
        axios.get(config.get('API_URL')+'/invoice/all_issuing_banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            response.data.map((issuBank,index) => {
                this.state.issuerBankList.push({value: issuBank.issuing_bank_id, label: issuBank.issuing_bank_name})
            });
        });
        this.setState({
            loading:false
        })
    }

    changeFrequency(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            frequency:value,
        });
        this._get_filtered_daily_settlement_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds, value, this.state.yestSend, this.state.todSend)
    }

    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this._get_filtered_daily_settlement_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds, this.state.frequency,
                this.state.yestSend, this.state.todSend)
        }
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    render() {
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
        };
        return (
          
                    <div className="content-invoice">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="col-md-9 no-padd">
                                            <div className="header">
                                                <h4 className="title">Rupay Settlement Report</h4>
                                                <p className="category"></p>
                                            </div>
                                        </div>
                                        <div className="col-md-3 pull-right">
                                            <div className="r-p-menu">
                                                {/*<SalesMenu></SalesMenu>*/}
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                        <div className="content">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label>Merchants</label>
                                                    <Select name="merchants"
                                                        isMulti
                                                        value={this.state.merchantValue}
                                                        styles={customStyles} className="report-listbox"
                                                        isClearable={false}
                                                        onChange={this.changeMerchant.bind(this, '')}
                                                        options={this.state.merchantList}
                                                        placeholder="Select [Merchant]"
                                                    />

                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-3">
                                            <label> Chain </label>
                                            <Select name="chain"
                                                    isMulti
                                                    value={this.state.chainValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeChain.bind(this,'')}
                                                    options={this.state.chainList}
                                                    placeholder="Select [Chain]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-3">
                                            <label> Store </label>
                                            <Select name="store"
                                                    isMulti
                                                    value={this.state.storeValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeStore.bind(this, '')}
                                                    options={this.state.storeList}
                                                    placeholder="Select [Store]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-3">
                                            <label>Frequency</label>
                                            <Select name="frequecy"
                                                    value={this.state.freValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeFrequency.bind(this)}
                                                    options={this.state.FrequencyList}
                                                    placeholder="Select [Frequency]"
                                            />
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="gap_ver"></div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label>Acquirer:</label>
                                            <Select name="acqurier"
                                                    isMulti
                                                    value={this.state.acqBankValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.change_acq_banks.bind(this)}
                                                    options={this.state.acqBankList}
                                                    placeholder="Select [Acquirer]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>
                                        {/*<div className="col-md-3">*/}
                                        {/*    <label> Issuer: </label>*/}
                                        {/*    <Select name="issuer"*/}
                                        {/*            isMulti*/}
                                        {/*            value={this.state.issuerBankValue}*/}
                                        {/*            styles={customStyles} className="report-listbox"*/}
                                        {/*            isClearable={false}*/}
                                        {/*            onChange={this.changeChain.bind(this,'')}*/}
                                        {/*            options={this.state.issuerBankList}*/}
                                        {/*            placeholder="Select[Issuer]"*/}
                                        {/*    />*/}
                                        {/*    <div className="clearfix"></div>*/}
                                        {/*</div>*/}
                                        <div className="col-md-3">
                                            <label> City: </label>
                                            <Select name="city"
                                                    isMulti
                                                    value={this.state.cityValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeCity.bind(this)}
                                                    options={this.state.cityLists}
                                                    placeholder="Select [City]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-3">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo} onEvent={this.handleEvent.bind(this)}>
                                                <i class="fa fa-calendar" aria-hidden="true"></i>
                                                <input type="text" name="dateRange" className="form-control dateRangeInput" value={this.state.datefromShow+' - '+this.state.dateToShow}/>
                                            </DateRangePicker>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadDailySettlementReport.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="DailySettTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Merchant</th>
                                                <th>Chain</th>
                                                <th>Store Name</th>
                                                <th>Pin Code</th>
                                                <th>City</th>
                                                <th>Acquirer Bank</th>
                                                <th>Utid</th>
                                                <th>Btid</th>
                                                <th>Settlement Date</th>
                                                <th>Total Settled Transactions</th>
                                                <th>Total Settled Value</th>
                                                <th>Total Unsettled Transactions</th>
                                                <th>Total Unsettled Value</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating CSV...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>

                                            <div className="footer">
                                                <div className="stats"><i></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
              
        );

    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(RupaySettlementReport);